<template>
  <div
    :style="getPersonalizedBox"
    class="w-full flex ticket-container mb-4 relative"
  >
    <div class="w-auto icon-container p-4 flex items-center">
      <img
        :src="require('@/assets/images/ic-ticket-purchase.svg')"
        :alt="$t('wegow.altIcon')"
        class="h-20 w-20 ticket-icon"
      />
    </div>
    <div
      class="w-full info-container flex flex-col justify-between ml-2 text-m"
    >
      <h3 :style="getPersonalizedTitle">{{ ticket.title }}</h3>
      <div :style="getPersonalizedPrice" class="price">
        <span>
          {{ formatCurrency(ticket.price, event.currency) }}
        </span>

        <span
          v-if="ticket.available === 0"
          :style="getPersonalizedTicketButton"
          class="disabled-info px-4 py-1"
        >
          {{
            ticket.reserved
              ? $t("wegow.purchase.reserved")
              : $t("wegow.purchase.soldOut")
          }}
        </span>
      </div>
      <p
        v-if="ticket.remaining > 0"
        :style="getPersonalizedAuxColor"
        class="remaining"
      >
        {{
          $t("wegow.purchase.remaining", { remainingTickets: ticket.remaining })
        }}
      </p>
      <div class="description" :style="getPersonalizedSubtitle">
        {{ ticket.description }}
      </div>
    </div>
    <div class="ticket-selector-container flex pr-6">
      <div
        v-if="ticket.available !== 0"
        class="selector-container flex justify-center items-center"
      >
        <button
          :style="getPersonalizedTicketButton"
          class="btn round minus transparent"
          type="button"
          :disabled="ticket.selecteds === 0"
          @mouseover="e => getPersonalizedTicketButton"
          @click="minusTicket(ticket.id)"
        >
          -
        </button>
        <span :style="getPersonalizedSubtitle" class="quantity mx-6">{{
          ticket.selecteds
        }}</span>
        <button
          :style="getPersonalizedTicketButton"
          class="btn round more transparent"
          type="button"
          :disabled="isDisabled(ticket)"
          @mouseover="e => getPersonalizedTicketButton"
          @click="addTicket(ticket.id)"
        >
          +
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
// TODO: revisar para el iframe con colores personalizados
import { useEvent } from "@/composables/useEvent";
import { usePurchase } from "@/composables/usePurchase";
import { useIframeStyle } from "@/composables/useIframeStyle";

import { computed, ref } from "vue";
import { formatCurrency } from "@/plugins/currency";

const { details: event } = useEvent();
const { addTicket, minusTicket, actualPurchase } = usePurchase();
const {
  getPersonalizedTitle,
  getPersonalizedSubtitle,
  getPersonalizedPrice,
  getPersonalizedAuxColor,
  getPersonalizedTicketButton,
  getPersonalizedBox
} = useIframeStyle();
const props = defineProps({
  ticket: {
    type: Object,
    required: true
  }
});
const isDisabled = ticket => {
  let total = 0;
  for (const ticketInPurchase of actualPurchase.value.selectedTickets) {
    total += ticketInPurchase.selecteds;
  }
  if (
    ticket.selecteds === ticket.max_tickets ||
    props.ticket.selecteds === event.max_tickets ||
    total === event.value.max_tickets ||
    ticket.selecteds === ticket.remaining ||
    ticket.selecteds === ticket.available
  )
    return true;
};
</script>

<style lang="scss" scoped>
.ticket-container {
  // background-color: $backgroundGrey;
  border-radius: 5px;

  .icon-container {
    background-color: $inputLigthBackground;
    border-radius: 5px 0px 0px 5px;
  }

  .info-container {
    background-color: $backgroundGrey;
    padding: 25px;
  }
  .ticket-selector-container {
    background-color: $backgroundGrey;
    font-size: 36px;
  }

  .price,
  .weswap-info {
    color: $topaz;
  }
  .disabled-info {
    background-color: $textSubtitle;
    color: $backgroundGrey;
    border-radius: 5px 0px;
  }
  hr {
    border: 1px solid $backgroundLightGrey;
  }
  .description {
    color: $textSubtitle;
  }
  .remaining {
    color: $malva;
  }
  .minus,
  .more {
    width: 60px;
    height: 60px;
    border: 1px solid $topaz;
    border-radius: 100%;
    color: $topaz;
    cursor: pointer;
    &:hover:not(:disabled) {
      background-color: transparent;
      color: $backgroundGrey;
    }
    &:disabled {
      border-color: $backgroundLightGrey;
      color: $backgroundLightGrey;
      cursor: not-allowed;
      &:hover {
        border-color: $backgroundLightGrey;
        color: $backgroundLightGrey;
        cursor: not-allowed;
      }
    }
  }
}
</style>
